import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormCaptureFields } from './types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { getDefaultFormCaptureConfig } from '@/utils/vsleads/getDefaultConfig';
import { VideoTab } from './form-capture/tabs/VideoTab';
import { LayoutTab } from './form-capture/tabs/LayoutTab';
import { FieldsTab } from './form-capture/tabs/FieldsTab';
import { TextsTab } from './form-capture/tabs/TextsTab';
import { StyleTab } from './form-capture/tabs/StyleTab';
import { TimerTab } from './form-capture/tabs/TimerTab';


interface VSLeadsFormCaptureProps {
  onSave?: (data: FormCaptureFields) => void;
  isSaving?: boolean;
  initialData?: FormCaptureFields;
  submitButtonText?: string;
}

export function VSLeadsFormCapture({
  onSave,
  isSaving = false,
  initialData,
  submitButtonText = 'Salvar Alterações'
}: VSLeadsFormCaptureProps) {
  useLanguage();
  const [activeTab, setActiveTab] = useState('video');
  
  const form = useForm<FormCaptureFields>({
    defaultValues: initialData || getDefaultFormCaptureConfig()
  });

  useEffect(() => {
    if (initialData) {
      form.reset(initialData);
    }
  }, [initialData, form]);

  const handleSubmit = (data: FormCaptureFields) => {
    if (onSave) {
      onSave(data);
    }
  };

  const isFormValid = form.watch('videoId') && form.watch('fields').length > 0;

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="flex flex-wrap gap-3 mb-8">
          <TabsTrigger value="video">{translateInterfaceText("Conteúdo")}</TabsTrigger>
          <TabsTrigger value="layout">{translateInterfaceText("Layout")}</TabsTrigger>
          <TabsTrigger value="fields">{translateInterfaceText("Campos")}</TabsTrigger>
          <TabsTrigger value="texts">{translateInterfaceText("Textos")}</TabsTrigger>
          <TabsTrigger value="style">{translateInterfaceText("Estilo")}</TabsTrigger>
          <TabsTrigger value="timer">{translateInterfaceText("Temporizador")}</TabsTrigger>
        </TabsList>

        <TabsContent value="video" className="mt-0 space-y-8">
          <VideoTab form={form} />
        </TabsContent>

        <TabsContent value="layout" className="mt-0 space-y-8">
          <LayoutTab form={form} />
        </TabsContent>

        <TabsContent value="fields" className="mt-0 space-y-8">
          <FieldsTab form={form} />
        </TabsContent>

        <TabsContent value="texts" className="mt-0 space-y-8">
          <TextsTab form={form} />
        </TabsContent>

        <TabsContent value="style" className="mt-0 space-y-8">
          <StyleTab form={form} />
        </TabsContent>

        <TabsContent value="timer" className="mt-0 space-y-8">
          <TimerTab form={form} />
        </TabsContent>
      </Tabs>

      <div className="flex gap-3 pt-4 border-t">
        <Button 
          onClick={() => form.reset()}
          variant="outline"
          className="flex-1"
        >
          {translateInterfaceText("Desfazer")}</Button>
        <Button 
          onClick={form.handleSubmit(handleSubmit)}
          disabled={!isFormValid || isSaving}
          className="flex-1"
        >
          {isSaving ? translateInterfaceText("Salvando...") : submitButtonText}
        </Button>
      </div>
    </div>
  );
}
